import {
  globalConstants,
  userConstants,
  adminUserConstants,
} from "../../constants";

const initialState = {
  page: {},
  pageData: [],
  openModal: false,
  approval: {
    page: {},
    pageData: [],
  },
  userData: [],
  approvalUserData: [],
  openAppRejModal: false,
  isUserApprovalModalOpen: false,
  adminUsersData: [],
  adminUserData: [],
  userSports: [],
  qualificationDocFormState: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case userConstants.USERS_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        ...action.data,
      };
    case userConstants.APPROVALS_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        approval: action.data,
      };
    case userConstants.OPEN_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        openModal: action.data,
      };
    case userConstants.OPEN_APPREJ_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        openAppRejModal: action.data,
      };
    case userConstants.USER_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        userData: action.data,
      };
    case userConstants.APPROVAL_USER_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        approvalUserData: action.data,
      };
    case userConstants.USER_SPORTS + globalConstants.SUCCESS:
      return {
        ...state,
        userSports: action.data.data,
      };
    case userConstants.USER_APPROVAL_VIEW_MODAL:
      return {
        ...state,
        isUserApprovalModalOpen: action.data,
      };
    case adminUserConstants.ADMIN_USERS_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        adminUsersData: action.data,
      };
    case adminUserConstants.GET_ADMIN_USER_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        adminUserData: action.data,
      };
    case userConstants.SET_QUALIFICATION_FORM_STATE:
      return {
        ...state,
        qualificationDocFormState: action.data,
      };
    default:
      return state;
  }
};

export default userReducer;
